import React from 'react';
import cx from 'clsx';
import { getSrc } from 'gatsby-plugin-image';

import CallIcon from '../Icons/Call';
import Image from '../Image';
import Link from '../Link';
import Navbar from './Navbar';
import { sendEvent } from '../../utils/ga';
import * as moduleStyles from './style.module.scss';
import * as themeStyles from '../../assets/theme.module.scss';
import logoQuery from '../../query/logoQuery';

const Header = ({ handleOnlineConsult }) => {
    const [isMobileDrawerOpen, setOpen] = React.useState(false);

    function handleOpenDrawer() {
        setOpen(true);
    }

    function handleCloseDrawer() {
        setOpen(false);
    }

    function onClickOnlineConsult() {
        handleOnlineConsult();
        sendEvent('Callout Header', 'click', 'online consult');
    }
    const logo = logoQuery();

    return (
        <>
            <header className={moduleStyles.header}>
                <nav
                    className={cx(
                        themeStyles.navbar,
                        themeStyles.navbarExpandLg,
                        moduleStyles.navbar,
                    )}
                >
                    <div className={themeStyles.container}>
                        <Link className={themeStyles.navbarBrand} to="/">
                            <Image
                                node={logo}
                                className={cx(
                                    themeStyles.navbarBrandImg,
                                    moduleStyles.logo,
                                )}
                                alt="建臺有限公司"
                                loading="eager"
                            />
                        </Link>
                        <div
                            className={cx(
                                'vcenter',
                                themeStyles.mlAuto,
                                themeStyles.mr9,
                                themeStyles.dNone,
                                themeStyles.dMdBlock,
                            )}
                        >
                            <CallIcon className="rotate-90" width={30} />
                            <span className={themeStyles.pl2}>
                                <a
                                    className="phone-text"
                                    href="tel:88662684508"
                                    onClick={() => sendEvent(
                                        'Callout Header',
                                        'click',
                                        'phone1',
                                    )}
                                >
                                    06-2684508
                                </a>
                                <br />
                                <a
                                    className={themeStyles.textGray900}
                                    href="mailto:contact@chientai.com.tw"
                                    onClick={() => sendEvent(
                                        'Callout Header',
                                        'click',
                                        'email',
                                    )}
                                >
                                    contact@chientai.com.tw
                                </a>
                            </span>
                        </div>
                        <button
                            type="button"
                            className={cx(
                                themeStyles.navbarBtn,
                                themeStyles.btn,
                                themeStyles.btnPrimarySoft,
                                themeStyles.btnSm,
                                themeStyles.lift,
                                themeStyles.dNone,
                                themeStyles.dMdBlock,
                            )}
                            onClick={onClickOnlineConsult}
                        >
                            線上詢價
                        </button>
                        <button
                            className={cx(
                                themeStyles.navbarToggler,
                                themeStyles.dBlock,
                                themeStyles.dMdNone,
                            )}
                            type="button"
                            aria-label="toggle"
                            onClick={handleOpenDrawer}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" height={25} width={25} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                    </div>
                </nav>
                <Navbar
                    isMobileDrawerOpen={isMobileDrawerOpen}
                    handleCloseDrawer={handleCloseDrawer}
                />
            </header>
        </>
    );
};

export default Header;
